import React, {useEffect, useState} from 'react'

import {MapBoundsContext} from './MapBoundsContext'
import {SettingsState} from './types'

const initialSettings: SettingsState = {shouldBounds: true}

const MapBoundsProvider: React.FC<React.PropsWithChildren<unknown>> = ({children}) => {
  const state = useState<SettingsState>(initialSettings)

  useEffect(() => {
    const [settings, setSettings] = state

    if (settings.shouldBounds === false) {
      const timeoutID = setTimeout(() => setSettings({shouldBounds: true}), 10000)

      return () => clearTimeout(timeoutID)
    }
  }, [state])

  return <MapBoundsContext.Provider children={children} value={state} />
}

export default MapBoundsProvider
